var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 23.9982,
    height: 23.9982,
    viewBox: "0 0 23.9982 23.9982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.0018 20.9958H15.0013",
    strokeWidth: 1.49989,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#850064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.0012 9.74652V11.2464C18.0012 14.5462 15.3014 17.246 12.0017 17.246C8.70193 17.246 6.00214 14.5462 6.00214 11.2464V9.74652",
    strokeWidth: 1.49989,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#850064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9995 17.2462V20.9959",
    strokeWidth: 1.49989,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#850064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.0016 2.99705C11.6071 2.99506 11.2161 3.07129 10.8513 3.22134C10.4865 3.37139 10.155 3.59228 9.87602 3.87123C9.59707 4.15018 9.37618 4.48166 9.22613 4.84651C9.07609 5.21136 8.99985 5.60233 9.00184 5.99682V11.1996C9.00184 12.8494 10.3611 14.2462 12.0016 14.2462C13.6421 14.2462 15.0014 12.8869 15.0014 11.1996V5.99682C15.0014 4.30945 13.689 2.99705 12.0016 2.99705Z",
    strokeWidth: 1.49989,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#850064"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic.27dc67803574d3c582c22cf6b32c829e.svg";